import { CurrencyPipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { PAYMENT_TYPES } from 'src/app/core/enums/payment-types.enum';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { DiscountsAndBonuses } from 'src/app/core/interfaces/discountsAndBonuses';
import { CargoPaymentDetail } from 'src/app/core/interfaces/cargoPayment';
import { AdminUsersService } from '../../administration/admin-users/admin-users.service';
import { UserClient } from 'src/app/core/interfaces/userClient';
import { DateManager } from 'src/app/core/managers/date.manager';
import { Permission } from 'src/app/core/resources/permission';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { CargoOptionsService } from '../cargo-options/cargo-options.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Utils } from 'src/app/core/resources/utils';
import { AuthService } from 'src/app/core/services/authentication.service';
import { environment } from 'src/environments/environment';
import { Fmt } from 'src/app/core/messages/fmt';

import { CargoItemService } from '../cargo-item/cargo-item.service';
import { Fingerprint } from 'src/app/core/interfaces/fingerprint';
@Component({
  selector: 'app-cargo-shipping-cost-dialog',
  templateUrl: './cargo-shipping-cost-dialog.component.html',
  styleUrls: ['./cargo-shipping-cost-dialog.component.scss'],
  providers: [CurrencyPipe],
})
export class CargoShippingCostDialogComponent {
  permission = Permission;
  typePayment = "DiscountsAndBonuses";
  shippingCostToDisplay: Array<DiscountsAndBonuses> = [];
  isLoadingRealtimePayments: boolean = false;
  users = {};
  // Ids ya solicitados: `users` solo se llena al responder el request, así que sin esta
  // marca N pagos del mismo usuario disparan N consultas simultáneas al mismo documento.
  private requestedUsers: { [id: string]: boolean } = {};
  public extraPaymentsByStatus: {
    processing: CargoPaymentDetail[];
    failed: CargoPaymentDetail[];
    deleted: CargoPaymentDetail[];
  } = { processing: [], failed: [], deleted: [] };
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title?: string,
      shippingCostToDisplay: Array<DiscountsAndBonuses>,
      typePayment?: string,
      cargo?: Cargo,
      finalRate?: number,
      finalCost?: number,
      balance?: number,
      paymentsByStatus?: { processing: CargoPaymentDetail[]; failed: CargoPaymentDetail[]; deleted: CargoPaymentDetail[] }
    },
    public ref: MatDialogRef<CargoShippingCostDialogComponent>,
    private adminUsersService: AdminUsersService,
    private router: Router,
    public matDialog: MatDialog,
    private currencyPipe: CurrencyPipe,
    private service: CargoOptionsService,
    private spinner: NgxSpinnerService,
    private snackBarService: SnackBarService,
    private permissionRole: PermissionRole,
    private authService: AuthService,
    private utils: Utils,
    public cargoItemService: CargoItemService
  ) {
    if (data && data.shippingCostToDisplay instanceof Array)
      this.updateShippingCostToDisplay(data.shippingCostToDisplay);
    if (data && data.typePayment) this.typePayment = data.typePayment;
    if (data && data.paymentsByStatus) this.updateExtraPaymentsByStatus(data.paymentsByStatus);
  }

  public updateShippingCostToDisplay(shippingCostToDisplay: Array<DiscountsAndBonuses>) {
    this.shippingCostToDisplay = shippingCostToDisplay instanceof Array ? shippingCostToDisplay : [];
    for (const shippingCost of this.shippingCostToDisplay) {
      this.getUser(shippingCost && shippingCost.userId ? shippingCost.userId : null);
    }
  }

  public updateExtraPaymentsByStatus(payload: { processing: CargoPaymentDetail[]; failed: CargoPaymentDetail[]; deleted: CargoPaymentDetail[] }): void {
    this.extraPaymentsByStatus = {
      processing: payload && Array.isArray(payload.processing) ? payload.processing : [],
      failed: payload && Array.isArray(payload.failed) ? payload.failed : [],
      deleted: payload && Array.isArray(payload.deleted) ? payload.deleted : []
    };
    const all: CargoPaymentDetail[] = [
      ...this.extraPaymentsByStatus.processing,
      ...this.extraPaymentsByStatus.failed,
      ...this.extraPaymentsByStatus.deleted
    ];
    for (const payment of all) {
      this.getUser(payment && payment.userId ? payment.userId : null);
    }
  }

  get showExtraSections(): boolean {
    return this.typePayment === 'Payments';
  }

  public setRealtimePaymentsLoading(isLoading: boolean): void {
    this.isLoadingRealtimePayments = !!isLoading;
  }

  getUser(id: string) {
    if (!id || this.users[id] || this.requestedUsers[id]) return;
    this.requestedUsers[id] = true;
    this.adminUsersService.getUserClientByDocument(id).subscribe(
      (success: UserClient[]) => {
        if (success && success.length) this.users[id] = success[0];
      },
      // Ante un error sí se libera la marca, para poder reintentar en la siguiente actualización.
      () => delete this.requestedUsers[id]
    );
  }

  get title(): string {
    return this.data && this.data.title ? this.data.title : this.typePayment === 'Payments' ? 'Histórico de pagos' : 'Descuentos y bonificaciones';
  }
  get subtitle(): string {
    if (this.typePayment === 'Payments') return 'Los pagos estarán marcados con un símbolo de asterisco (*) y en color azul.';
    if (this.typePayment === 'DiscountsAndBonuses') return 'Detalle de los movimientos de descuentos y bonificaciones en el servicio, las bonificaciones serán positivas y los descuentos negativos.';
    if (this.typePayment === 'DiscountsAndBonusesDeleted') return 'Detalle de los movimientos de descuentos y bonificaciones eliminados en el servicio, las bonificaciones serán positivas y los descuentos negativos.';
    if (this.typePayment === 'PaymentsDeleted') return 'Detalle de los pagos eliminados en el servicio.';
    return '';
  }

  getDeletedFingerprint(shippingCost: DiscountsAndBonuses): Fingerprint {
    if (shippingCost.deletedFingerPrint && shippingCost.deletedFingerPrint.fingerPrint)
      return shippingCost.deletedFingerPrint.fingerPrint;
    if (shippingCost.fingerprintDeleted) return shippingCost.fingerprintDeleted;
    return null;
  }

  showDeleteButton(): boolean {
    return ['Payments', 'DiscountsAndBonuses'].includes(this.typePayment) && !!this.data.cargo;
  }

  canDeleteElement(paymentOrDiscount: DiscountsAndBonuses): { canDelete: boolean, error?: string } {
    //Eliminación de bonos y descuentos
    if (this.typePayment === 'DiscountsAndBonuses') {
      const type = paymentOrDiscount.type == 0 ? 'bono' : 'descuento';
      const isPaid = this.utils.getNestedValue(this.data.cargo, 'shippingCost.paid');
      const isCashed = this.utils.getNestedValue(this.data.cargo, 'shippingCost.cashed');
      const isValidated = this.utils.getNestedValue(this.data.cargo, 'prevalidation.valid');
      if (!this.utils.isDefined(paymentOrDiscount.id)) return { canDelete: false, error: ServiceMessages.UNABLE_DELETE_DISCOUNT.replace('%s', type) };
      if (isPaid && !!paymentOrDiscount.amount) return { canDelete: false, error: `No es posible eliminar un ${type} al flete de un servicio pagado` };
      if (isCashed && !!paymentOrDiscount.amountRate) return { canDelete: false, error: `No es posible eliminar un ${type} a la tarifa de un servicio facturado` };
      if (isValidated && !!paymentOrDiscount.amountRate) return { canDelete: false, error: `No es posible eliminar un ${type} a la tarifa de un servicio validado para facturar` };
      if (!this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.deleteBonusesAndDiscounts)) return { canDelete: false, error: `No cuentas con el permiso necesario para eliminar este ${type}` };
      if (type === 'bono') {
        if (!this.utils.isDefined(this.data.balance)) return { canDelete: false, error: `No es posible eliminar este bono, por favor ingresa al detalle del servicio para poder hacer la eliminación.` };
        if (paymentOrDiscount.amount && this.data.balance <= 0) return { canDelete: false, error: `No es posible eliminar el bono, ya que el saldo del servicio es inferior o igual a cero.` };
        if (paymentOrDiscount.amountRate && this.data.finalRate && this.data.finalRate - paymentOrDiscount.amountRate < 0)
          return { canDelete: false, error: `No es posible eliminar el bono, ya que el valor resultante de la tarifa del servicio sería inferior a cero.` };
        if (paymentOrDiscount.amount && this.data.finalCost && this.data.finalCost - paymentOrDiscount.amount < 0)
          return { canDelete: false, error: `No es posible eliminar el bono, ya que el valor resultante del flete del servicio sería inferior a cero.` };
        if (paymentOrDiscount.amount && this.data.balance - paymentOrDiscount.amount < 0)
          return { canDelete: false, error: `No es posible eliminar el bono, ya que el valor resultante del saldo del servicio sería inferior a cero.` };
      }
      if (paymentOrDiscount.observation === "Descuento por la aceptacion del pronto pago")
        return { canDelete: false, error: `No es posible eliminar un descuento por la aceptacion del pronto pago` };
      return { canDelete: true };
    }
    //Eliminación de pagos
    if (!this.utils.isDefined(paymentOrDiscount.id)) return { canDelete: false, error: "Solo es posible eliminar pagos posteriores al 16 de Febrero de 2024" };
    if (!this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.deletePayment)) return { canDelete: false, error: "No cuentas con el permiso necesario para eliminar este pago" };
    if (paymentOrDiscount.type === 'balance' && (!this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.deleteBalancePayment)))
      return { canDelete: false, error: "No cuentas con el permiso necesario para eliminar el pago del saldo" };
    return { canDelete: true };

  }

  async openDialogDelete(paymentOrDiscount: DiscountsAndBonuses) {
    const { canDelete, error } = this.canDeleteElement(paymentOrDiscount);
    if (!canDelete) return this.snackBarService.openSnackBar(error, undefined, 'error');
    const type = this.typePayment === 'Payments' ? 'pago' : paymentOrDiscount.type == 0 ? 'bono' : 'descuento';
    const config = new MatDialogConfig();
    const messageList = [
      `Servicio: ${this.data.cargo.consecutive}`,
      `Fecha: ${DateManager.formatDate(paymentOrDiscount.date, 'YYYY-MM-DD HH:mm ZZ', 'YYYY-MM-DD hh:mm a')}`,
    ];
    if (this.typePayment === 'DiscountsAndBonuses') {
      if (!!paymentOrDiscount.amount) messageList.push(`Flete: ${this.currencyPipe.transform(paymentOrDiscount.amount, "COP", "code")}`);
      if (!!paymentOrDiscount.amountRate) messageList.push(`Tarifa: ${this.currencyPipe.transform(paymentOrDiscount.amountRate, "COP", "code")}`);
    } else {
      const amount = paymentOrDiscount.amount ? paymentOrDiscount.amount : paymentOrDiscount.amountRate;
      messageList.push(`Valor: ${amount ? this.currencyPipe.transform(amount, "COP", "code") : '0 COP'}`);
    }
    config.data = {
      title: `¿Estás seguro que deseas eliminar este ${type}?`,
      description: `No se podrá reversar esta operación, ¿Deseas continuar?`,
      messageList: messageList,
      showYesBtn: true,
      showNoBtn: true
    };
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.width = ModalEnum.SMALL_WIDTH;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    config.autoFocus = false;
    const result = await this.matDialog.open(DialogComponent, config).afterClosed().toPromise();
    if (!result || !result.state) return;
    let success: boolean = false;
    if (this.typePayment === 'DiscountsAndBonuses')
      success = (await this.deleteDiscountOrBonus(paymentOrDiscount)).success;
    else
      success = (await this.deletePayment(paymentOrDiscount)).success;
    if (!success) return this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
    this.snackBarService.openSnackBar(ServiceMessages.DELETE_SUCCESS.replace('%s', type));
    this.ref.close({ state: true });
  }

  private async deleteDiscountOrBonus(discountOrBonus: DiscountsAndBonuses): Promise<{ success: boolean }> {
    this.spinner.show();
    try {
      await this.service.deleteDiscountOrBonus(this.data.cargo.id, discountOrBonus.id).toPromise();
      this.spinner.hide();
      return { success: true };
    } catch (e) {
      this.spinner.hide();
      return { success: false };
    }
  }

  private async deletePayment(payment: DiscountsAndBonuses): Promise<{ success: boolean }> {
    this.spinner.show();
    let response: any;
    try { response = await this.service.deletePayment(this.data.cargo.id, payment.id).toPromise(); } catch (e) { };
    this.spinner.hide();
    if (response && response['message'] && response['message'] === "Delete") return { success: true };
    return { success: false };
  }
}
